import * as Vue from 'vue';
import { isBoolean, isArray, has, forEach, isString, isNil, cloneDeep, pull, reject, omit, sortBy } from 'lodash';
import { rulesMutatorApplicator } from './RulesMutatorApplicator';
import { transmitter } from './Transmitter';
// import { DISABLED_VALUE } from '../../constants';

const answerFactory = (uuID, value) =>
{
    return {
        questionID: uuID,
        answer: value,
    };
};

const getCloneAnswerAsArray = (original) =>
{
    const answer = cloneDeep(original);
    if (isString(answer.answer))
    {
        if (answer.answer.length)
        {
            answer.answer = [answer.answer];
        }
        else
        {
            answer.answer = [];
        }
    }
    return answer;
};

const mutations = {

    /**
     * Payload:
     * @param string
     * @param int
     * @param string|object
     */
    INIT_ANSWER (state, [uukey, uuid, answer])
    {
        Vue.set(state.answers, uukey, answerFactory(uuid, answer));
    },

    /**
     * Payload:
     * @param string
     * @param int
     * @param string|object
     */
    INIT_STORE (state, [key, values])
    {
        if (key === 'counties' || key === 'municipalities')
        {
            Vue.set(state, key, sortBy(values, 'name'));
        }
        else
        {
            Vue.set(state, key, values);
        }
    },

    /**
     * Payload:
     * @param int
     * @param int
     */
    INIT_COMPLETION (state, [num, value])
    {
        const completion = completionValidNumber(value);
        Vue.set(state.completions, num, completion);
    },

    /**
     * Payload:
     * @param int
     * @param int
     */
    INIT_DEBUGGER_ANSWER (state, [uukey, scoreAndCompleted])
    {
        Vue.set(state.debugger, uukey, scoreAndCompleted);
    },

    SYNC_ANSWERS (state, [data])
    {
        forEach(data, ({ values, uuid }, uukey) =>
        {
            Vue.set(state.answers, uukey, answerFactory(uuid, JSON.parse(values)));
        });
    },

    UPDATE_DEBUGGER_SCORES (state, scores)
    {
        forEach(scores, (score, uukey) =>
        {
            Vue.set(state.debugger, uukey, JSON.parse(score));
        });
    },

    /**
     * Payload:
     * @param string
     * @param string|object
     * @param string|null
     * @param string|null
     */
    STORE_ANSWER (state, [uukey, value, row, col])
    {
        const mutatedAnswer = rulesMutatorApplicator.applyAnswer(state.answers[uukey], value, row, col);
        // state.answers = { ...state.answers, [uukey]: mutatedAnswer }
        Vue.set(state.answers, uukey, mutatedAnswer);
        transmitter.submitAnswer(uukey, mutatedAnswer.questionID, mutatedAnswer.answer)

        const mutatedAnswers = rulesMutatorApplicator.applyRules(state.answers);
        forEach(mutatedAnswers, (mutedObj) =>
        {
            Vue.set(state.answers, mutedObj.uukey, mutedObj.mutatedAnswer);
            transmitter.submitAnswer(mutedObj.uukey, mutedObj.mutatedAnswer.questionID, mutedObj.mutatedAnswer.answer)
        });
    },

    /**
     * Payload:
     * @param string
     * @param string|object
     * @param string|null
     * @param string|null
     */
    STORE_ADD_TO_ANSWER (state, [uukey, value, row, col])
    {
        const answer = getCloneAnswerAsArray(state.answers[uukey]);
        if (answer.answer.indexOf(value) < 0)
        {
            answer.answer.push(value);

            const mutatedAnswer = rulesMutatorApplicator.applyAnswer(state.answers[uukey], answer.answer, row, col);
            Vue.set(state.answers, uukey, mutatedAnswer);
            transmitter.submitAnswer(uukey, mutatedAnswer.questionID, mutatedAnswer.answer)

            const mutatedAnswers = rulesMutatorApplicator.applyRules(state.answers);
            forEach(mutatedAnswers, (mutedObj) =>
            {
                Vue.set(state.answers, mutedObj.uukey, mutedObj.mutatedAnswer);
                transmitter.submitAnswer(mutedObj.uukey, mutedObj.mutatedAnswer.questionID, mutedObj.mutatedAnswer.answer)
            });
        }
    },

    /**
     * Payload:
     * @param string
     * @param string|object
     * @param string|null
     * @param string|null
     */
    STORE_REMOVE_FROM_ANSWER (state, [uukey, value, row, col])
    {
        const answer = getCloneAnswerAsArray(state.answers[uukey])

        pull(answer.answer, value);

        const mutatedAnswer = rulesMutatorApplicator.applyAnswer(state.answers[uukey], answer.answer, row, col);
        Vue.set(state.answers, uukey, mutatedAnswer);
        transmitter.submitAnswer(uukey, mutatedAnswer.questionID, mutatedAnswer.answer)

        const mutatedAnswers = rulesMutatorApplicator.applyRules(state.answers);
        forEach(mutatedAnswers, (mutedObj) =>
        {
            Vue.set(state.answers, mutedObj.uukey, mutedObj.mutatedAnswer);
            transmitter.submitAnswer(mutedObj.uukey, mutedObj.mutatedAnswer.questionID, mutedObj.mutatedAnswer.answer)
        });
    },

    /**
     * Payload:
     * @param string
     * @param string|number
     */
    STORE_REMOVE_COL_FROM_ANSWER (state, [uukey, col])
    {
        const mutatedAnswers = getCloneAnswerAsArray(state.answers[uukey]);

        forEach(mutatedAnswers.answer, (mutatedRow, rowID) =>
        {
            const cleaned = omit(mutatedRow, col);
            mutatedAnswers.answer[rowID] = cleaned;
        });

        Vue.set(state.answers, uukey, mutatedAnswers);
        transmitter.submitAnswer(uukey, mutatedAnswers.questionID, mutatedAnswers.answer)
    },

    /**
     * Payload:
     * @param int
     * @param int
     */
    SET_COMPLETION (state, [num, value])
    {
        const completion = completionValidNumber(value);
        const completions = cloneDeep(state.completions);
        completions[num] = completion;
        state.completions = completions;
    },

    /**
     * Payload:
     * @param string
     * @param object
     */
    STORE_2D_INCLUSIVE_DYNAMIC_UPDATE (state, [source, objct])
    {
        const $store = cloneDeep(state[source]);
        let idx = null;

        forEach($store, (item, key) =>
        {
            if (objct.id === item.id)
            {
                idx = key;
                return false;
            }
        });

        if (isNil(idx))
        {
            $store.push(objct);
            Vue.set(state, source, $store);
        }
        else
        {
            Vue.set(state[source], idx, objct);
        }
    },

    /**
     * Payload:
     * @param string
     * @param object
     */
    STORE_2D_INCLUSIVE_DYNAMIC_UPDATE_ALL (state, [source, $store])
    {
        Vue.set(state, source, $store);
    },

    /**
     * Payload:
     * @param string
     * @param int
     */
    DELETE_2D_INCLUSIVE_DYN_ROW (state, [source, rowID])
    {
        const $store = cloneDeep(state[source]);
        const $newStore = reject($store, (item) => rowID == item.id);

        Vue.set(state, source, $newStore);
    },

    /**
     * Payload:
     * @param string
     * @param object
     */
    PUSH_2D_INCLUSIVE_DYN_ROW (state, [source, elm])
    {
        const $store = cloneDeep(state[source]);

        $store.push(elm)
        Vue.set(state, source, $store);
    },

    /**
     * Payload:
     * @param string
     */
    DELETE_ALL_2D_INCLUSIVE_DYN_ROW (state, [source])
    {
        Vue.set(state, source, []);
    },

    INCREMENT_HELP_COUNTER (state)
    {
        state.helpCounter += 1;
    },

    POSTFILL_BUTTON_TO_HIDDEN (state)
    {
        state.postFillButtonHidden = true;
    },

    SET_REGIONS_LIST (state, [values])
    {
        Vue.set(state, 'regions', values);
    },

    SET_COUNTIES_LIST (state, [values])
    {
        Vue.set(state, 'counties', values);
    },

    SET_MUNICIPALITIES_LIST (state, [values])
    {
        Vue.set(state, 'municipalities', values);
    },

    SET_SELECTED_PROVINCE_REGIONS (state, [key, selectedValues])
    {
        if (key === `allProvince`)
        {
            if (isBoolean(selectedValues))
            {

                Vue.set(state, key, selectedValues);
            }
        }
        else if (has(state.selectedRegions, key))
        {
            if (isArray(selectedValues))
            {
                Vue.set(state.selectedRegions, key, selectedValues);

            }
        }
    },

    SET_SELECTED_ANSWERS_FOR_SECTION (state, [sectionKey, selectedAnswers])
    {
        if (has(state.selectedAnswers, sectionKey))
        {
            Vue.set(state.selectedAnswers, sectionKey, selectedAnswers);
        }
    },

    SET_EXPORT_BUILDINGS (state, [isBuildingPicked])
    {
        Vue.set(state, 'exportBuildings', isBuildingPicked);
    },
};

const completionValidNumber = (value) => Math.min(100, (Math.max(0, parseInt(value, 10))));

export { mutations }



// WEBPACK FOOTER //
// ./resources/assets/js/components/vuex/storeMutators.js